require 'lib/jquery.plugin'